import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function safeReplace() {
  // Versuch 1: WMP Search&Replace Plugin
  const sr = window.wmpapi?.v1?.searchAndReplace;
  if (sr && typeof sr.replace === "function") {
    try {
      sr.replace();
      return true;
    } catch (e) {
      // Wichtig: nicht crashen
      console.warn("[MatelsoSpaScan] sr.replace failed:", e?.message || e);
    }
  }

  // Versuch 2 (optional): falls mtls vorhanden ist, SPA Scan
  if (window.mtls?.loaded && typeof window.mtls.scan === "function") {
    try {
      window.mtls.scan(document.getElementById("root") || document);
      return true;
    } catch (e) {
      console.warn("[MatelsoSpaScan] mtls.scan failed:", e?.message || e);
    }
  }

  return false;
}

export default function MatelsoSpaScan() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    const start = Date.now();
    const timeoutMs = 6000;

    const tick = () => {
      // warten bis WMP da ist
      if (!window.wmpapi?.v1) {
        if (Date.now() - start > timeoutMs) return;
        requestAnimationFrame(tick);
        return;
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          safeReplace();
          // nachziehen (React DOM kann nachlaufen)
          setTimeout(safeReplace, 600);
        });
      });
    };

    tick();
  }, [pathname, search, hash]);

  return null;
}
